module.exports = __webpack_public_path__ + "static/ff-landing-image-body-asyouwatch-forfeathering-elliott-stallion-Tz_ikM242f4-unsplash.a531aa92.jpg";